import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sentry } from "@utils/sentry";

interface SentryPerformanceProps {
  children: React.ReactNode;
}

export const SentryPerformance: React.FC<SentryPerformanceProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Add breadcrumb for route changes
    Sentry.addBreadcrumb({
      category: "navigation",
      message: `Navigated to ${location.pathname}`,
      level: "info",
      data: {
        from: location.pathname,
        search: location.search,
        hash: location.hash,
      },
    });
  }, [location]);

  return <>{children}</>;
}; 